import React, { Component } from "react"
import { Menu, Input, Icon, DatePicker, Pagination, Affix, Checkbox, Row, Modal } from "antd"
import ReportCard from "app/components/normal/azf/ReportCard"
import reportIcon from "app/styles/images/sp/report-selected.svg"
import "./Index.scss"
import moment from "moment"
import { observer, inject } from "mobx-react"
import Store from "app/stores/azf/report"
import queryString from "query-string"
import { Route } from 'react-router-dom'
import ReportDetail from "app/components/normal/azf/ReportDetail"

const RangePicker = DatePicker.RangePicker
const { Search } = Input

@inject('entrance', 'auth') @observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
    this.state = {
      currentPageIndex: 1,
      isHistory: "查看历史数据",
      dateValue: null,
      tableData: [],
      totalCount: 0,
      reportGroupData: {},
      app: "0",              //头部筛选选中的状态 计算
      belong: "all",         //头部筛选选中的状态 自己 分享
      dayKey: "-1",          //头部筛选选中的状态 日期
      checkState: "all"

    }
  }

  onDataChange = (e, type) => {
    switch (type) {
      case "belong": this.onBelongChange(e)
        break
      case "app": this.onAppChange(e)
        break
      case "day": this.onDayChange(e)
        break
      default: this.dateChangeOk()
    }
  }

  onBelongChange = (e) => {
    this.setState({
      belong: e.key,
    })
    let { list: { filterData } } = this.store

    filterData({ belong: e.key })
  }

  onAppChange = (e) => {
    this.setState({
      app: e.key,
    })
    let { list: { queryMap } } = this.store
    let appQueryValue = null
    let isHistory = ""
    if (e.key === 0 || e.key === "0") {
      appQueryValue = null
      isHistory = "查看历史数据"
    } else if (e.key === "app_id_999" && queryMap.app === "999") {
      isHistory = "查看历史数据"
      appQueryValue = null
    } else if (e.key === "app_id_999" && (queryMap.app !== "999" || queryMap.app === null)) {
      isHistory = "关闭历史数据"
      appQueryValue = "999"
    } else {
      let appIdString = (e.key).replace("app_id_", "")
      appQueryValue = appIdString
      isHistory = "查看历史数据"
    }
    this.setState({
      isHistory
    })
    const { history, match } = this.props
    const { inputSearch } = this.state
    history.push({
      pathname: `${match.url}/search`,
      search: queryString.stringify({ // 此处不可以使用 beautifyObj，不传 keywords 会导致本次查询复用上次的 keywords(此处可拓展其他字段)
        keywords: inputSearch,
        app: appQueryValue
      })
    })
  }

  changeSearch = (e) => {
    const keywords = e.target.value
    this.setState({
      inputSearch: keywords,
    })
  }
  searchData = () => {
    const { match, history } = this.props
    history.push({
      pathname: `${match.url}/search`,
      search: queryString.stringify({
        keywords: this.state.inputSearch,
        app: this.state.appQueryValue
      })
    })
  }

  dateChange = (dateValue, dateString) => {
    const { list: { updateQueryMap } } = this.store
    updateQueryMap({ start: dateString[0], end: dateString[1] })
    this.setState({     //日期回显
      dateValue: dateValue
    })
  }

  dateChangeOk = () => {
    this.setState({  // 重置近几天的选项
      dayKey: "-1",
    })
    let {
      list: { filterData, queryMap }
    } = this.store

    filterData({ end: moment(queryMap.end, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
  }

  onDayChange = (e) => {
    let startDay = null
    const {
      list: { filterData }
    } = this.store

    this.setState({  //设置近几天同时重置日期选择
      dayKey: e.key,
      dateValue: null,
    })
    if (e.key !== "-1") {
      startDay = moment(moment() - e.key * 1000 * 3600 * 24).format("YYYY-MM-DD")
    }

    filterData({ start: startDay, end: null })
  }

  componentWillReceiveProps(nextProps) {
    const { location } = this.props
    const { location: nextLocation } = nextProps
    if (nextLocation.search && queryString.parse(nextLocation.search).holdData) {
      return
    }

    if (nextLocation.search !== location.search) {
      const searchObj = queryString.parse(nextLocation.search)
      this.setState({
        inputSearch: searchObj.keywords
      })
      if (nextLocation.search) {
        this.loadLimitedData(searchObj)
      } else {
        this.loadAllData()
      }
    }
  }

  componentDidMount() {
    const { list } = this.store

    list.getApps('common');
    (() => {
      if (location.search) {
        const searchObj = queryString.parse(location.search)
        this.setState({
          inputSearch: searchObj.keywords
        })
        return this.loadLimitedData(searchObj)
      } else {
        return this.loadAllData()
      }
    })().then(() => {
      const pathArr = location.pathname.split('/')
      const reportId = pathArr.slice(-1)[0]
      if (pathArr.slice(-2)[0] === 'detail') {
        this.initDetailData(reportId)
      }
    })
  }

  loadLimitedData(queryObj) {
    return this.store.list.filterData(queryObj, 'notInitPage')
  }

  loadAllData() {
    const { list } = this.store
    return list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
        }
      )
  }

  onShowSizeChange = (current, pageSize) => {
    const { list: { filterData } } = this.store

    filterData({ limit: pageSize })
  }

  onPaginChange = selectedPageNumber => {
    let {
      list
    } = this.store

    list.changePagin(selectedPageNumber)
    document.getElementById("contentTop").scrollIntoView(true)
  }

  disabledDate = (current) => {
    return current && current.valueOf() > Date.now()
  }

  closeModal = (modal, cb) => {
    this.setState({
      [modal]: false
    })
    if (typeof cb === "function") {
      cb()
    }
  }

  /**
   * 只会在刷新页面的时候调用
   **/
  initDetailData = (reportId) => {
    const { getDetailData, list: { tableData } } = this.store

    let reportGroupData = tableData.find(
      data => {
        let index = data.reportList.findIndex(report => report.reportId === reportId)
        if (index > -1) {
          this.setState({
            dataIndex: index
          })
        }
        return index > -1
      }
    )

    this.setState({ reportGroupData })

    getDetailData(reportId)
  }

  dataSwitch = (index, record) => {
    let { getDetailData, clearDetailData } = this.store

    clearDetailData()

    this.setState({
      dataIndex: index,
    })

    getDetailData(record.reportId)
      .then(res => {
        record.isRead = true
      })
  }

  openReportDetail = (data, record) => {
    let { getDetailData } = this.store
    let { history, match } = this.props

    const index = data.reportList.findIndex(report =>
      report.reportId === record.reportId
    )

    this.setState({
      dataIndex: index,
      reportGroupData: data
    })

    let reportId = data.reportList[index].reportId
    getDetailData(reportId)
      .then(() => {
        record.isRead = true
      })
    history.push({
      pathname: `${match.url}/detail/${reportId}`,
      search: queryString.stringify({ // 此处不可以使用 beautifyObj，不传 keywords 会导致本次查询复用上次的 keywords(此处可拓展其他字段)
        holdData: true
      })
    })
  }

  onCheckStateChange = (e) => {
    const { list: { filterData } } = this.store
    this.setState({
      checkState: e.key
    })
    filterData({ state: e.key === 'all' ? null : e.key })
  }

  render() {
    const { list: { tableData, totalCount, currentPageIndex, queryMap } } = this.store
    const { match, history, entrance } = this.props
    const { reportGroupData, dataIndex } = this.state
    let tmp = this.store.detailData
    let templates = entrance.templates
    return (
      <div className="azf report-page">
        <h2 className="page-title"><img alt="" src={reportIcon} />报告列表</h2>
        {this.renderHeader()}
        <div className="report-card-wrap">
          {tableData.map((data, index) =>
            <ReportCard
              key={data.groupId + "_groupId"}
              onOpenDetail={this.openReportDetail}
              data={data}
              gorupIndex={index}
              store={this.store}
            />
          )}
        </div>
        {/* 报告详情modal */}
        <Route
          path={`${match.url}/detail/:id`}
          render={() => {
            return (
              <Modal
                title="报告详情"
                width={1172}
                footer={0}
                maskClosable={false}
                visible={true}
                onCancel={history.goBack}
                className="detail-modal"
              >
                <ReportDetail
                  data={reportGroupData}
                  index={dataIndex}
                  reportDetail={this.store.detailData} // null observable object
                  reportList={reportGroupData.reportList}
                  templates={templates}
                  dataSwitch={this.dataSwitch}
                  store={this.store}
                  groupId={reportGroupData.groupId}
                />
              </Modal>
            )
          }}
        />
        <div className="pagin-bottom">
          <Pagination
            showSizeChanger
            pageSize={queryMap.limit}
            onShowSizeChange={this.onShowSizeChange}
            onChange={this.onPaginChange}
            defaultCurrent={1}
            current={currentPageIndex}
            total={totalCount} />
        </div>
      </div>
    )
  }

  toggleUnread = (e) => {
    const {
      list
    } = this.store

    list.filterData({ unread: e.target.checked })
  }

  renderHeader = () => {
    const { inputSearch } = this.state
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}>
        <div className="affix-back">
          <div className="first-line">
            {this.renderUserMenu()}
            {this.renderDayMenu()}
          </div>
          <Row type="flex" justify="space-between" align="middle">
            <div className="report-search-bar">
              <Row type="flex" justify="space-between" align="middle" className="content">
                <Row type="flex" align="middle">
                  <div className="search-input">
                    <Search
                      value={inputSearch}
                      placeholder="输入文件名/样本名/所在分组搜索"
                      size="default"
                      onChange={this.changeSearch.bind(this)}
                      onSearch={this.searchData}
                    />
                  </div>
                  <div className="unread-btn">
                    <Checkbox onChange={this.toggleUnread} >只看未读</Checkbox>
                  </div>
                </Row>
              </Row>
            </div>

            {this.renderAppMenu()}
          </Row>
        </div>
      </Affix>
    )
  }

  renderUserMenu = () => {
    return (
      <div className="user-menu">
        <Menu
          className="menu-all" onClick={e => this.onDataChange(e, "belong")}
          key="menu_share_0"
          selectedKeys={[this.state.belong]}
          mode="horizontal">
          <Menu.Item key="all">
            <Icon type="cloud-o" />全部
          </Menu.Item>
          <Menu.Item key="self">
            <Icon type="team" />自己的
          </Menu.Item>
          <Menu.Item key="share">
            <Icon type="share-alt" />分享而来
          </Menu.Item>
        </Menu>
      </div>
    )
  }

  renderAppMenu = () => {
    const { list: { apps } } = this.store
    const { userInfo } = this.props.auth
    return (
      <div className="menu-app-azf">
        <Menu
          className="menu-app"
          onClick={e => this.onDataChange(e, "app")}
          selectedKeys={[this.state.app]}
          key="menu_app_0"
          mode="horizontal">
          <Menu.Item key="0">
            <Icon type="calculator" />全部计算
          </Menu.Item>
          {apps.map((item, index) =>
            <Menu.Item key={"app_id_" + item.id} title={item.name}>
              {item.name}
            </Menu.Item>
          )}
        </Menu>
        {userInfo.id === '64' && (
          <div className="auditStatus">
            <Menu
              onClick={e => this.onCheckStateChange(e)}
              selectedKeys={[this.state.checkState]}
              mode="horizontal"
              key="menu_date_0"
            >
              <Menu.Item key="all">
                全部
              </Menu.Item>
              <Menu.Item key="1">
                未审核
              </Menu.Item>
              <Menu.Item key="2">
                已审核
              </Menu.Item>
              <Menu.Item key="3">
                已复核
              </Menu.Item>
            </Menu>
          </div>
        )}
      </div>
    )
  }

  renderDayMenu = () => {
    return (
      <div className="report-search-time-bar">
        <Menu className="menu-day" onClick={e => this.onDataChange(e, "day")}
          selectedKeys={[this.state.dayKey]}
          mode="horizontal"
          key="menu_date_0">
          <Menu.Item key="-1">
            <Icon type="calendar" />全部
          </Menu.Item>
          <Menu.Item key="0">今天</Menu.Item>
          <Menu.Item key="3">三天内</Menu.Item>
          <Menu.Item key="7">七天内</Menu.Item>
          <Menu.Item key="15">十五天内</Menu.Item>
          <Menu.Item key="30">三十天内</Menu.Item>
        </Menu>
        <RangePicker
          ranges={{
            "今天": [moment(), moment()],
            "本月": [moment().startOf("month"), moment()]
          }}
          showTime
          value={this.state.dateValue}
          onChange={this.dateChange}
          onOk={this.onDataChange}
          disabledDate={this.disabledDate}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/azf/report/index.js